import PropTypes from 'prop-types';
// @mui
import { Fab, Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

// Written for LTR; the app's global stylis-plugin-rtl (see ThemeRtlLayout)
// automatically mirrors this to the left edge when the language is Arabic.
// Do not manually flip left/right here — that would double-mirror.
const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: 20,
  right: 20,
  zIndex: theme.zIndex.speedDial,
  boxShadow: theme.shadows[8],
}));

// ----------------------------------------------------------------------

ChatButton.propTypes = {
  onClick: PropTypes.func,
  unreadCount: PropTypes.number,
};

export default function ChatButton({ onClick, unreadCount }) {
  return (
    <StyledFab color="primary" onClick={onClick}>
      <Badge badgeContent={unreadCount} color="error" max={6}>
        <Iconify icon="ic:baseline-chat-bubble-outline" width={24} height={24} />
      </Badge>
    </StyledFab>
  );
}
